/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Components
import InfoHero from '../../components/heros/information';
import Footer from '../../components/footer';
import Reviews from '../../components/sections/reviews';
// React Router
import { Link } from 'react-router-dom';
// Images
import vanilla from '../../assets/images/minecraft/vanilla.svg';
import spigot from '../../assets/images/minecraft/spigot.svg';
import paper from '../../assets/images/minecraft/paper.svg';
import atl from '../../assets/images/minecraft/atl.svg';
import ftb from '../../assets/images/minecraft/ftb.svg';
import bukkit from '../../assets/images/minecraft/bukkit.svg';
import pixelmon from '../../assets/images/minecraft/pixelmon.svg';
import technic from '../../assets/images/minecraft/technic.svg';

const Modpack = () => {
    return (
        <main>
            <InfoHero title="Supported Modpacks & Versions" description="With us you can switch versions without hastle." />
            <section className='modpacks py-28 max-w-8xl mx-auto px-5 sm:px-5 lg:px-5'>
                <div className='primary-gradient px-6 sm:px-6 md:px-6 lg:px-16 rounded-xl pt-16 pb-28'>
                    <div className='grid grid-cols-1 gap-9'>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-5 items-center'>
                                <div>
                                    <img src={vanilla} alt="Vanilla" className='w-48' />
                                </div>
                                <div>
                                    <h1 className='text-gray-100 font-semibold text-2xl'>Java Edition</h1>
                                </div>
                                <div className='col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-2'>
                                    <p className='text-gray-300 text-lg'>Minecraft: Java Edition is the unaltered version of the game that you on PC. Simple and fun!</p>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-5 items-center'>
                                <div>
                                    <img src={paper} alt="Paper" className='w-48' />
                                </div>
                                <div>
                                    <h1 className='text-gray-100 font-semibold text-2xl'>PaperMC</h1>
                                </div>
                                <div className='col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-2'>
                                    <p className='text-gray-300 text-lg'>A fork of Spigot that focuses on performance. Many additional optimization options & other quality of life features.</p>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-5 items-center'>
                                <div>
                                    <img src={spigot} alt="Spigot" />
                                </div>
                                <div>
                                    <h1 className='text-gray-100 font-semibold text-2xl'>Spigot</h1>
                                </div>
                                <div className='col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-2'>
                                    <p className='text-gray-300 text-lg'>Backed by a massive and active community, Spigot is a modified version of Minecraft that enables plugins & optimizations.</p>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-5 items-center'>
                                <div>
                                    <img src={bukkit} alt="Bukkit" />
                                </div>
                                <div>
                                    <h1 className='text-gray-100 font-semibold text-2xl'>Bukkit</h1>
                                </div>
                                <div className='col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-2'>
                                    <p className='text-gray-300 text-lg'>Bukkit or Craftbukkit is the original API that allows users to add plugins to Minecraft. Currently maintaiend by Spigot.</p>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-5 items-center'>
                                <div>
                                    <img src={pixelmon} alt="Pixelmon" />
                                </div>
                                <div>
                                    <h1 className='text-gray-100 font-semibold text-2xl'>Pixelmon</h1>
                                </div>
                                <div className='col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-2'>
                                    <p className='text-gray-300 text-lg'>Pixelmon is a fan-created modpack that merges the worlds of Minecraft and Pokemon! Capture, train, and battle!</p>
                                </div>
                            </div>
                        </div>
                        <div className='bg-primaryDark py-9 px-10 rounded-md'>
                            <div className='grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-5 items-center'>
                                <div>
                                    <img src={atl} alt="ATL" />
                                </div>
                                <div>
                                    <h1 className='text-gray-100 font-semibold text-2xl'>ATLauncher</h1>
                                </div>
                                <div className='col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-2'>
                                    <p className='text-gray-300 text-lg'>ATLauncher distributes a large number of the most popular modpacks. Users can easily download and install modpacks.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='get-started pt-28 pb-36 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5'>
                <div className='bg-primaryDark rounded-xl pt-10 pb-12 px-10'>
                    <div className='header mb-12'>
                        <h1 className='text-center text-gray-100 text-3xl font-semibold mb-4'>Ready to get started?</h1>
                        <p className='text-center text-gray-300'>We always make sure you get what you pay for. Performance, Great support, and Reliability.</p>
                    </div>
                    <div className='body'>
                        <div className='flex justify-center items-center'>
                            <div className='mr-7'>
                                <a href="https://client.cyperhost.com/submitticket.php" className="bg-gray-100 border border-gray-100 px-7 py-3 text-gray-900 font-semibold rounded-md text-base">Contact Us</a>
                            </div>
                            <div>
                                <Link to="/games/minecraft" className="bg-primary border border-primary px-7 py-3 text-gray-300 font-semibold rounded-md text-base">View Pricing</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Reviews />
            <Footer />
        </main>
    )
}

export default Modpack